import { motion } from "framer-motion";

/**
 * Shared dark hero for interior pages.
 * Keeps consistent Dark Premium styling with minimal code.
 */
export default function PageHero({ badge, title, titleAlt, subtitle, align = "left", accent = true, children, rightSlot = null }) {
  const alignCls = align === "center" ? "text-center items-center mx-auto" : "";
  return (
    <section className="relative bg-[#0A0A0A] text-white overflow-hidden pt-32 md:pt-40 pb-20 md:pb-28">
      <div className="grain absolute inset-0 opacity-40 pointer-events-none"></div>
      {accent && (
        <>
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#FF3B30]/20 rounded-full blur-[160px] pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#007AFF]/12 rounded-full blur-[140px] pointer-events-none"></div>
        </>
      )}
      <div className={`relative max-w-7xl mx-auto px-6 md:px-10 ${alignCls} ${rightSlot ? "grid lg:grid-cols-12 gap-10 lg:gap-14 items-center" : ""}`}>
        <div className={rightSlot ? "lg:col-span-7" : ""}>
          {badge && (
            <motion.div
              initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
              className={`inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 backdrop-blur px-4 py-1.5 text-xs font-bold tracking-[0.2em] uppercase text-white/80`}
            >
              <span className="w-2 h-2 rounded-full bg-[#FF3B30] pulse-dot"></span>
              {badge}
            </motion.div>
          )}
          <motion.h1
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.08 }}
            className="font-display mt-6 text-[44px] md:text-7xl lg:text-[88px] font-extrabold tracking-[-0.03em] leading-[0.96] max-w-6xl"
          >
            {title}{titleAlt && (<><br/><span className="italic font-light text-white/40">{titleAlt}</span></>)}
          </motion.h1>
          {subtitle && (
            <motion.p
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.16 }}
              className="mt-7 max-w-2xl text-lg md:text-xl text-white/60 leading-relaxed"
            >
              {subtitle}
            </motion.p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
        {rightSlot && (
          <div className="lg:col-span-5">
            {rightSlot}
          </div>
        )}
      </div>
    </section>
  );
}
